import { observer } from 'mobx-react';
import { CardItem, StatusCard, tryPrintPercentage } from 'Mri.Web.Common';
import * as React from 'react';

export interface IDisplayBrightnessCardProps {
    readonly statusPoll?: Mri.DisplayStatuses.DisplayStatusPoll;
    readonly loading?: boolean;
}

@observer
export class DisplayBrightnessCard extends React.Component<IDisplayBrightnessCardProps> {
    public render() {
        const statusPoll = this.props.statusPoll;
        return (
            <StatusCard title="Brightness" loading={this.props.loading}>
                {statusPoll?.backlights?.map((b, idx) => (
                    <div key={b.name + idx}>
                        {statusPoll.backlights!.length > 1 && b.name && <CardItem label={b.name} value="" header />}

                        <CardItem label="Brightness" value={b.brightness} />

                        <CardItem label="Desired Brightness" value={b.desiredBrightness} />

                        <CardItem label="PWM" value={tryPrintPercentage(b.pwm)} />

                        <CardItem label="DAC" value={tryPrintPercentage(b.dac)} />

                        <CardItem label="Avg Light Sensor" value={b.avgLightSensor} />

                        <CardItem label="Avg Temperature" value={b.avgTemperature} />

                        {b.blockDimmingState != null && (
                            <CardItem
                                label="Block Dimming State"
                                value={b.blockDimmingState ? 'Enabled' : 'Disabled'}
                            />
                        )}
                        {b.blockDimmingPercentEnabled != null && (
                            <CardItem
                                label="Block Dimming Percent Enabled"
                                value={b.blockDimmingPercentEnabled + '%'}
                            />
                        )}
                    </div>
                ))}
            </StatusCard>
        );
    }
}
